import css from 'styled-jsx/css';
import { colors, icons } from '../../config/styles';
import { svgToDataUri } from '../../utils/styles/svgMixins';

const ShippingDetailsStyles = css`
  .shipping-details {
    display: flex;
    flex-direction: column;
    padding: 0 0 4px 0;
    list-style: none;

    li {
      display: flex;

      @mixin mobileToTablet {
        align-items: baseline;
      }
    }

    .icon {
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 0;

      @mixin tabletToDesktop {
        margin-bottom: 4px;
      }
    }

    .shipping-wrapper {
      display: flex;
      margin-bottom: 4px;
      .shipping-box {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background-color: #f1f1f1;
        border-radius: 4px;
        padding: 2px 4px;

        span {
          font-size: 1.2rem;
          color: #008000;
        }
      }
    }
    .shipping-text {
      margin-bottom: 5px;
    }
    .boomIcon {
      background-image: url('/a/fa/listing/static/styles/svg/boomIcon.svg');
      background-repeat: no-repeat;
      width: 60px;
      height: 13px;
      margin-bottom: 12px;
      display: flex;
    }
    .csicon-succes {
      color: ${colors.green.shade1};
      font-size: 9px;

      @mixin desktop {
        font-size: 11px;
      }
    }
    .rebranding-sucess-icon {
      background: url('/a/fa/listing/static/styles/svg/rebranding-sucess-icon.svg') no-repeat center;
      width: 9px;
      height: 9px;
      background-size: 9px;
      @mixin desktop {
        width: 11px;
        height: 11px;
        background-size: 11px;
        margin-top: 1px;
      }
    }
    .rebranding-sucess-icon-list {
      background: url('/a/fa/listing/static/styles/svg/rebranding-sucess-icon.svg') no-repeat center;
      width: 11px;
      height: 9px;
      background-size: 11px;
      margin-top: 1px;
    }
    .rebranding-sucess-icon-grid {
      background: url('/a/fa/listing/static/styles/svg/rebranding-sucess-icon.svg') no-repeat center;
      width: 14px;
      height: 14px;
      background-size: 14px;
      margin-top: 1px;
    }
    .icon-1_GRID {
      background-size: contain;
      width: 75px;
      height: 15px;
      margin-top: 5px;
      margin-bottom: 13px;
    }
    .csicon-succes-1_GRID {
      font-size: 14px;
    }
    .express-icon,
    .scheduled-icon,
    .store-icon {
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      height: 16px;
      width: 16px;
      flex-shrink: 0;
    }

    .express-icon {
      background-image: url('${svgToDataUri(icons.expressShipping)}');
    }

    .scheduled-icon {
      background-image: url('${svgToDataUri(icons.scheduledShipping)}');
    }

    .store-icon {
      background-image: url('${svgToDataUri(icons.pickupFromStoreShipping)}');
    }

    .highlight {
      font-weight: 700;
    }
  }
`;

export { ShippingDetailsStyles };
